import * as types from './types'
import { createAction } from 'Utils/redux'

export const setTheme = createAction(types.THEME_SET_THEME, 'theme')
